



import { defineComponent } from '@nuxtjs/composition-api';

import BiuraGlowna from '~/components/biura/components/biura-glowna.vue';

export default defineComponent({
  components: { BiuraGlowna },
  middleware: ['biura/routeAuth'],
});
